var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ym-no-record-com"},[_vm._t("default",function(){return [_vm._v("暂无数据")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }